<template>
  <b-container
    class="m-1 w-100 report-text-main"
    fluid
  >
    <b-row
      class="pt-1 pl-1"
      @mouseover="onHover('ReportViewer/nameReport')"
      @mouseleave="onLeave"
    >
      <b-col
        v-if="!isExportingReportViewer"
        cols="auto"
        class="p-0"
      >
        <h5
          v-if="editable"
          class="num-id-edit"
        >
          {{ getShortIdCurrentReportViewer }}.
        </h5>
        <h3
          v-else
          class="report-name"
        >
          {{ getShortIdCurrentReportViewer }}.
        </h3>
      </b-col>
      <b-col :class="[isExportingReportViewer?'p-0':'']">
        <b-form-input
          v-if="editable"
          v-model="NameReport"
          placeholder="Enter the name of the report"
          class="report-name-input"
        />
        <h3
          v-else
          class="report-name"
        >
          {{ NameReport }}
        </h3>
      </b-col>
      <b-col
        v-if="!isVisibleExportPDFReportViewer"
        cols="auto"
        class="report-more-options"
      >
        <b-dropdown
          size="sm"
          variant="link"
          toggle-class="text-decoration-none"
          no-caret
        >
          <template #button-content>
            <b-icon
              icon="download"
              aria-hidden="true"
            />
          </template>
          <b-dropdown-item-button @click="setVisibleExportPDFReportViewer(true); setLoadingMainApp(true);">
            <b-icon
              icon="file-earmark-post"
              aria-hidden="true"
              class="mr-2"
              scale="1.2"
            />
            Export as PDF
          </b-dropdown-item-button>
          <b-dropdown-item-button @click="downloadRawDataToCSV">
            <b-icon
              icon="file-earmark-ruled"
              aria-hidden="true"
              class="mr-2"
              scale="1.2"
            />
            Export raw data to CSV
          </b-dropdown-item-button>
          <b-dropdown-item-button @click="downloadRawData">
            <b-icon
              icon="cloud-download"
              aria-hidden="true"
              class="mr-2"
              scale="1.2"
            />
            Download Raw Data
          </b-dropdown-item-button>
          <b-dropdown-item-button @click="$emit('downloadProcessedData')">
            <b-icon
              icon="file-earmark-spreadsheet"
              aria-hidden="true"
              class="mr-2"
              scale="1.2"
            />
            Download Analysis Results
          </b-dropdown-item-button>
        </b-dropdown>
      </b-col>
    </b-row>
    <b-row
      class="pl-1"
      @mouseover="onHover('ReportViewer/lastUpdate')"
      @mouseleave="onLeave"
    >
      <p class="last-modification">
        Last Update: {{ getCurrentReportViewer.dateLastUpdate }}
      </p>
    </b-row>
    <b-row
      v-if="DateTest!=='' || editable"
      class="date-row"
      @mouseover="onHover('ReportViewer/dateTest')"
      @mouseleave="onLeave"
    >
      <b-col
        class="label-report pr-0"
        md="auto"
      >
        <p class="p-label-report p-label-inline">
          Date of Test<span v-if="editable">*</span>:
        </p>
      </b-col>
      <b-col
        cols="9"
        class="pl-1"
        md="auto"
      >
        <b-form-input
          v-if="editable && !isComparisonReport"
          v-model="DateTest"
          size="sm"
          type="date"
          class="report-date-input"
        />
        <p
          v-else
          class="value-report"
        >
          {{ DateTest }}
        </p>
      </b-col>
    </b-row>
    <b-row
      v-if="Operator!=='' || editable"
      class="pl-3 pt-0"
      @mouseover="onHover('ReportViewer/operator')"
      @mouseleave="onLeave"
    >
      <p class="p-label-report p-label-block">
        Operator<span v-if="editable">*</span>:
      </p>
    </b-row>
    <b-row
      v-if="Operator!=='' || editable"
      class="pl-5"
      @mouseover="onHover('ReportViewer/operator')"
      @mouseleave="onLeave"
    >
      <textarea
        v-if="editable"
        v-model="Operator"
        placeholder="Enter the id of the operator"
        size="sm"
        class="text-area-input"
        @input="mixin_autoResize_resize"
      />
      <div
        v-else
        class="value-report multiline"
      >
        {{ Operator }}
      </div>
    </b-row>
    <b-row
      v-if="Hypothesis!=='' || editable"
      class="pl-3 pt-0"
      @mouseover="onHover('ReportViewer/hypothesis')"
      @mouseleave="onLeave"
    >
      <p class="p-label-report p-label-block">
        Hypothesis<span v-if="editable">*</span>:
      </p>
    </b-row>
    <b-row
      v-if="Hypothesis!=='' || editable"
      class="pl-5"
      @mouseover="onHover('ReportViewer/hypothesis')"
      @mouseleave="onLeave"
    >
      <textarea
        v-if="editable"
        v-model="Hypothesis"
        placeholder="Enter a hypothesis of the experiment"
        size="sm"
        class="text-area-input"
        @input="mixin_autoResize_resize"
      />
      <div
        v-else
        class="value-report multiline"
      >
        {{ Hypothesis }}
      </div>
    </b-row>
    <b-row
      v-if="Protocol!=='' || editable"
      class="pl-3 pt-0"
      @mouseover="onHover('ReportViewer/protocol')"
      @mouseleave="onLeave"
    >
      <p class="p-label-report p-label-block">
        Experimental Protocol<span v-if="editable">*</span>:
      </p>
    </b-row>
    <b-row
      v-if="Protocol!=='' || editable"
      class="pl-5"
      @mouseover="onHover('ReportViewer/protocol')"
      @mouseleave="onLeave"
    >
      <textarea
        v-if="editable"
        v-model="Protocol"
        placeholder="Enter an experimental protocol of the analysis"
        size="sm"
        class="text-area-input"
        @input="mixin_autoResize_resize"
      />
      <div
        v-else
        class="value-report multiline"
      >
        {{ Protocol }}
      </div>
    </b-row>
    <b-row
      v-if="Equipment!=='' || editable"
      class="pl-3 pt-0"
      @mouseover="onHover('ReportViewer/equipment')"
      @mouseleave="onLeave"
    >
      <p class="p-label-report p-label-block">
        Equipment Used<span v-if="editable">*</span>:
      </p>
    </b-row>
    <b-row
      v-if="Equipment!=='' || editable"
      class="pl-5"
      @mouseover="onHover('ReportViewer/equipment')"
      @mouseleave="onLeave"
    >
      <textarea
        v-if="editable"
        v-model="Equipment"
        placeholder="Define the equipment used in the analysis"
        size="sm"
        class="text-area-input"
        @input="mixin_autoResize_resize"
      />
      <div
        v-else
        class="value-report multiline"
      >
        {{ Equipment }}
      </div>
    </b-row>
    <b-row
      v-if="Results!=='' || editable"
      class="pl-3 pt-0"
      @mouseover="onHover('ReportViewer/results')"
      @mouseleave="onLeave"
    >
      <p class="p-label-report p-label-block">
        Main Results:
      </p>
    </b-row>
    <b-row
      v-if="Results!=='' || editable"
      class="pl-5"
      @mouseover="onHover('ReportViewer/results')"
      @mouseleave="onLeave"
    >
      <textarea
        v-if="editable"
        v-model="Results"
        placeholder="Enter the main results"
        size="sm"
        class="text-area-input"
        @input="mixin_autoResize_resize"
      />
      <div
        v-else
        class="value-report multiline"
      >
        {{ Results }}
      </div>
    </b-row>
    <b-row
      v-if="Conclusion!=='' || editable"
      class="pl-3 pt-0"
      @mouseover="onHover('ReportViewer/conclusion')"
      @mouseleave="onLeave"
    >
      <p class="p-label-report p-label-block">
        Conclusion:
      </p>
    </b-row>
    <b-row
      v-if="Conclusion!=='' || editable"
      class="pl-5"
      @mouseover="onHover('ReportViewer/conclusion')"
      @mouseleave="onLeave"
    >
      <textarea
        v-if="editable"
        v-model="Conclusion"
        placeholder="Enter a short conclusion of the report"
        size="sm"
        class="text-area-input"
        @input="mixin_autoResize_resize"
      />
      <div
        v-else
        class="value-report multiline"
      >
        {{ Conclusion }}
      </div>
    </b-row>
    <b-row
      v-if="SensorBatchId!=='' || editable"
      class="pl-3 pt-0"
      @mouseover="onHover('ReportViewer/sensorBatchId')"
      @mouseleave="onLeave"
    >
      <p class="p-label-report p-label-block">
        Sensor Batch Id:
      </p>
    </b-row>
    <b-row
      v-if="SensorBatchId!=='' || editable"
      class="pl-5"
      @mouseover="onHover('ReportViewer/sensorBatchId')"
      @mouseleave="onLeave"
    >
      <textarea
        v-if="editable && !isComparisonReport"
        v-model="SensorBatchId"
        placeholder="Enter the Id of the Sensor Batch"
        size="sm"
        class="text-area-input"
        @input="mixin_autoResize_resize"
      />
      <div
        v-else
        class="value-report multiline"
      >
        {{ SensorBatchId }}
      </div>
    </b-row>
    <b-row
      v-if="Details!=='' || editable"
      class="pl-3 pt-0"
      @mouseover="onHover('ReportViewer/details')"
      @mouseleave="onLeave"
    >
      <p class="p-label-report p-label-block">
        Details:
      </p>
    </b-row>
    <b-row
      v-if="Details!=='' || editable"
      class="pl-5"
      @mouseover="onHover('ReportViewer/details')"
      @mouseleave="onLeave"
    >
      <textarea
        v-if="editable"
        v-model="Details"
        placeholder="Enter details of the report"
        size="sm"
        class="text-area-input"
        @input="mixin_autoResize_resize"
      />
      <div
        v-else
        class="value-report multiline"
      >
        {{ Details }}
      </div>
    </b-row>
    <b-row
      class="pl-3 pt-0"
      @mouseover="onHover('ReportViewer/reviewers')"
      @mouseleave="onLeave"
    >
      <p class="p-label-report p-label-block">
        Reviewers:
      </p>
    </b-row>
    <b-row
      class="pl-5 mt-3 mb-8"
      @mouseover="onHover('ReportViewer/reviewers')"
      @mouseleave="onLeave"
    >
      <EmailMultiSelect
        v-if="editable && getCurrentReportViewer.owner"
        :initial-selected="getReviewers"
        @userAdded="addReviewers"
      />
      <div
        v-else
        id="reviewers"
        class="value-report multiline"
      >
        <span
          v-for="(reviewer, index) in getReviewers"
          :key="index"
          class="custom-tag"
        >{{ reviewer.name }}</span>
      </div>
      <b-tooltip
        v-if="editable && !getCurrentReportViewer.owner"
        target="reviewers"
        placement="left"
      >
        Only the owner of the report can define reviewers
      </b-tooltip>
    </b-row>
    <b-row
      v-if="isComparisonReport"
      class="pl-3"
      @mouseover="onHover('ReportViewer/comparisonReportsId')"
      @mouseleave="onLeave"
    >
      <p class="p-label-report p-label-block">
        Reports:
      </p>
    </b-row>
    <b-row
      v-if="isComparisonReport"
      class="pl-5"
      @mouseover="onHover('ReportViewer/reportsComparison')"
      @mouseleave="onLeave"
    >
      <textarea
        v-if="editable"
        v-model="reportsComp"
        placeholder="Enter the reports to compare"
        size="sm"
        class="text-area-input"
        @input="mixin_autoResize_resize"
        @blur="validateReportsComp"
      />
      <ul v-else>
        <li 
          v-for="reportComparing in getCurrentReportViewer.comparing"
          :key="reportComparing.id"
        >
          <a
            class="value-report"
            :href="`/reportViewer/${getCurrentClusterNavigation}/${getCurrentProjectNavigation}/report/${reportComparing.id}`"
            target="_blank"
          >
            ({{ reportComparing.studies }}) {{ reportComparing.shortId }}{{ typeof(getDictReportsByUIdReportViewer[reportComparing.id]) !== 'undefined' ? `. ${getDictReportsByUIdReportViewer[reportComparing.id].name}` : '' }}
          </a>
        </li>
      </ul>
    </b-row>
  </b-container>
</template>

<script>
import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'
import { mapActions,mapGetters } from 'vuex'
import { getDataFiles } from '@/functions/extractData.js'
import EmailMultiSelect from '../inputs/EmailMultiSelect.vue'
import { getReportFilesCount } from '@/common/commonFunctions.js';
import { Comparison_Type } from '@/common/sharedDefinitions/reportDefinitions.js';
import { TYPE_PSSESSION, TYPE_2D } from '@/common/sharedDefinitions/dataExtractors/baseExtractor.js';



const downloadRaw_Message = 'Downloading Raw Files...'
const downloadFilesNumberWarning = 25
const notifyZone = 'ReportTextData'
const separatorCompReports = '\n'
const reNumber=RegExp('\\d+')

const saveData = (function () {
  var a = document.createElement('a');
  document.body.appendChild(a);
  a.style = 'display: none';
  return function (blob, fileName) {
    var url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  };
})();

export default {
  name: 'ReportTextData',
	components:{
		EmailMultiSelect
	},
  props: {
    editable:{
      type:Boolean,
      required: true
    }
  },
  data() {
    return{
      ConfigName,
      buttonsChrono:[],
      reportsComp: ''
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentReportViewer',
      'isVisibleExportPDFReportViewer',
      'getShortIdCurrentReportViewer',
      'isExportingReportViewer',
      'getDictReportsByUIdReportViewer',
      'getCurrentClusterNavigation',
      'getCurrentProjectNavigation',
      'getDictIdReportsReportViewer',
    ]),
    isComparisonReport(){
      return this.getCurrentReportViewer.type===Comparison_Type
    },
    NameReport:{
      set (value) {
        this.$set(this.getCurrentReportViewer, 'name', value)
        this.userUpdate()
      },
      get () {
        return this.getCurrentReportViewer.name||''
      },
    },
    DateTest:{
      set (value) {
        this.$set(this.getCurrentReportViewer, 'dateTest', value)
        this.userUpdate()
      },
      get () {
        return this.getCurrentReportViewer.dateTest||''
      }
    },
    Operator:{
      set (value) {
        this.$set(this.getCurrentReportViewer, 'operator', value)
        this.userUpdate()
      },
      get () {
        return this.getCurrentReportViewer.operator||''
      }
    },
    Protocol:{
      set (value) {
        this.$set(this.getCurrentReportViewer, 'protocol', value)
        this.userUpdate()
      },
      get () {
        return this.getCurrentReportViewer.protocol||''
      }
    },
    Hypothesis:{
      set (value) {
        this.$set(this.getCurrentReportViewer,'hypothesis',value)
        this.userUpdate()
      },
      get () {
        return this.getCurrentReportViewer.hypothesis||''
      }
    },
    Equipment:{
      set (value) {
        this.$set(this.getCurrentReportViewer, 'equipment', value)
        this.userUpdate()
      },
      get () {
        return this.getCurrentReportViewer.equipment||''
      }
    },
    Results:{
      set (value) {
        this.$set(this.getCurrentReportViewer, 'results', value)
        this.userUpdate()
      },
      get () {
        return this.getCurrentReportViewer.results||''
      }
    },
    Conclusion:{
      set (value) {
        this.$set(this.getCurrentReportViewer, 'conclusion', value)
        this.userUpdate()
      },
      get () {
        return this.getCurrentReportViewer.conclusion||''
      }
    },
    SensorBatchId:{
      set (value) {
        this.$set(this.getCurrentReportViewer, 'sensorBatchId', value)
        const proyID =this.getCurrentReportViewer.projectId
        this.getCurrentReportViewer.sensorBatchIdProj = proyID+'_'+value
        this.userUpdate()
      },
      get () {
        return this.getCurrentReportViewer.sensorBatchId||''
      }
    },
    Details:{
      set (value) {
        this.$set(this.getCurrentReportViewer, 'details', value)
        this.userUpdate()
      },
      get () {
        return this.getCurrentReportViewer.details||''
      }
    },
    getReviewers() {
      return this.getCurrentReportViewer.reviewers || []
    }
  },
  mounted(){
    this.updateReportsComp();
  },
  watch:{
    async editable(newValue){
      if(newValue){
        await this.$nextTick()
        await this.$nextTick()
        this.updateReportsComp()
        const textAreas = this.$el.querySelectorAll('.text-area-input');
        for(const textArea of textAreas){
          this.resize_manual(textArea)
        }
      }
    }
  },
  methods:{
    ...mapActions([
      'setReportModifiedReportViewer',
      'setContextOnHover',
      'setVisibleExportPDFReportViewer',
      'setLoadingMainApp',
      'setMessageTextReportViewer',
      'setMessageVisibleReportViewer',
      'downloadRawFilesMiddleware',
      'setForceUpdateReportViewer',
    ]),
    onHover(route) {
      this.setContextOnHover(route)
    },
    onLeave(){
      this.setContextOnHover(null)
    },
    userUpdate(){
      this.setReportModifiedReportViewer()
      this.getCurrentReportViewer.dateLastUpdate = new Date().toLocaleString()
    },
    refreshInformation(){
      this.updateReportsComp()
    },
    updateReportsComp(){
      if(typeof this.getCurrentReportViewer.comparing !== 'undefined' && this.getCurrentReportViewer.comparing.length > 0){
        this.reportsComp = (this.getCurrentReportViewer.comparing.map(r => r.shortId)).join(separatorCompReports);
      }else{
        this.reportsComp = '';
      }
    },
    validateReportsComp(){
      let validIds = []
      let validShortIds = []
      for(const newShortIdStr of this.reportsComp.split(separatorCompReports)){
        try{
          let reportFound = undefined;
          if(typeof(this.getDictReportsByUIdReportViewer[newShortIdStr]) !== 'undefined')
            reportFound = this.getDictReportsByUIdReportViewer[newShortIdStr];
          const newShortId = parseInt(newShortIdStr)
          if(typeof(this.getDictIdReportsReportViewer[newShortId]) !== 'undefined')
            reportFound = this.getDictIdReportsReportViewer[newShortId];

          if(typeof(reportFound) !== 'undefined'){
            validIds.push(reportFound.id);
            validShortIds.push(reNumber.exec(reportFound.shortId.toString())[0]);
            continue
          }
          const warnTitle = 'Short Id not found in current project';
          const warnText = `ShortId ${newShortIdStr} was not found in current project`;
          this.$notifTerm.addNotification(this.$notifTerm.typesNotif.WARNING, warnTitle, warnText, notifyZone);
        }catch{
          const warnTitle = 'Short Id not identified';
          const warnText = `ShortId ${newShortIdStr} not identified`;
          this.$notifTerm.addNotification(this.$notifTerm.typesNotif.WARNING, warnTitle, warnText, notifyZone);
        }
      }
      if(validIds.length < 2){
        const errTitle = 'Minimum reports quantify';
        const errText = 'Comparing report requires at least 2 valid reports';
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
        this.updateReportsComp();
        return;
      }
      this.userUpdate();
      this.reportsComp = validShortIds.join(separatorCompReports);
      this.$set(this.getCurrentReportViewer, 'comparing', validIds.map(id=> {return {id:id, shortId:id, studies:[]}}));
      this.setForceUpdateReportViewer(1); //Force update from backend
    },
    resize_manual(target) {
      target.style.height = 'auto';
      target.style.height = `${target.scrollHeight}px`;
    },
    mixin_autoResize_resize(event) {
      event.target.style.height = 'auto';
      event.target.style.height = `${event.target.scrollHeight}px`;
    },
    set_value_in_matrix(matrix, line, col, value){
      while(matrix.length <= line){
        matrix.push([])
      }
      if(matrix[line].length == col){
        matrix[line].push(String(value))
      }else{
        while(matrix[line].length <= col){
          matrix[line].push('')
        }
        matrix[line][col] = String(value)
      }
    },
    set_array_in_column_matrix(matrix, start_line, col, array){
      for(let f = 0; f < array.length; f++){
        this.set_value_in_matrix(matrix, start_line + f, col, array[f])
      }
    },
    async downloadRawDataToCSV(){
      this.setMessageTextReportViewer(downloadRaw_Message)
      this.setMessageVisibleReportViewer(true)
      try{
        const dataTypeFiles = await getDataFiles(this.getCurrentReportViewer);
        let csv_matrix =[]
        let col_pointer = 0
        for (let j = 0; j < dataTypeFiles.length; j++) {
        const file = dataTypeFiles[j];
          for (let n = 0; n < file.extractedData.length; n++) {
            if (typeof file.extractedData[n].enabled !== 'undefined' && !file.extractedData[n].enabled) {
              //If the data is not enabled it is not included on the exported data
              continue;
            }
            this.set_value_in_matrix(csv_matrix, 0, col_pointer, 'Name')
            this.set_value_in_matrix(csv_matrix, 0, col_pointer + 1, file.extractedData[n].title)
            this.set_value_in_matrix(csv_matrix, 1, col_pointer, 'Id')
            this.set_value_in_matrix(csv_matrix, 1, col_pointer + 1, `"${j}.${n}"`)
            if (file.type === TYPE_PSSESSION) {
              const reverse_current = typeof(file.extractedData[n].reverseCurrent) !== 'undefined' && file.extractedData[n].reverseCurrent.length > 0
              // Column A
              if(typeof(file.extractedData[n].frequency) !== 'undefined'){
                this.set_value_in_matrix(csv_matrix, 2, col_pointer, 'f')
                this.set_array_in_column_matrix(csv_matrix, 3, col_pointer, file.extractedData[n].frequency)
              }else{
                this.set_value_in_matrix(csv_matrix, 2, col_pointer, 't')
                this.set_array_in_column_matrix(csv_matrix, 3, col_pointer, file.extractedData[n].time)
              }
              // Column B
              if(typeof(file.extractedData[n].impedance_re) !== 'undefined'){
                this.set_value_in_matrix(csv_matrix, 2, col_pointer + 1, 're')
                this.set_array_in_column_matrix(csv_matrix, 3, col_pointer + 1, file.extractedData[n].impedance_re)
              }else{
                this.set_value_in_matrix(csv_matrix, 2, col_pointer + 1, 'E')
                this.set_array_in_column_matrix(csv_matrix, 3, col_pointer + 1, file.extractedData[n].potential)
              }
              // Column C
              if(typeof(file.extractedData[n].impedance_im) !== 'undefined'){
                this.set_value_in_matrix(csv_matrix, 2, col_pointer + 2, 'im')
                this.set_array_in_column_matrix(csv_matrix, 3, col_pointer + 2, file.extractedData[n].impedance_im)
              }else{
                this.set_value_in_matrix(csv_matrix, 2, col_pointer + 2, reverse_current ? 'i-forward' : 'i')
                this.set_array_in_column_matrix(csv_matrix, 3, col_pointer + 2, file.extractedData[n].current)
              }
              // Optional reverse current
              if(reverse_current){
                this.set_value_in_matrix(csv_matrix, 2, col_pointer + 3, 'i-reverse')
                this.set_array_in_column_matrix(csv_matrix, 3, col_pointer + 3, file.extractedData[n].reverseCurrent)
                col_pointer++
              }
              col_pointer += 3
            } else if (file.type === TYPE_2D) {
              this.set_value_in_matrix(csv_matrix, 2, col_pointer, 'x')
              this.set_array_in_column_matrix(csv_matrix, 3, col_pointer, file.extractedData[n].X)
              this.set_value_in_matrix(csv_matrix, 2, col_pointer + 1, 'y')
              this.set_array_in_column_matrix(csv_matrix, 3, col_pointer + 1, file.extractedData[n].Y)
              col_pointer += 2
            } else{
                const warnTitle = 'Unknown data type';
                const warnText = `The file category '${file.type}' isn't recognized. Please contact the administrator of the system`;
                parent.$notifTerm.addNotification(
                    parent.$notifTerm.typesNotif.WARNING,
                    warnTitle,
                    warnText,
                    notifyZone,
                );
            }
          }
        }
        const csv_1D_arr = Array.from(csv_matrix, (line_matrix) => line_matrix.join(','))
        const blob = new Blob([csv_1D_arr.join('\n')], { type: 'text/csv;charset=utf-8;' });
        saveData(blob, `${this.getCurrentReportViewer.name} Processed Data.csv`);
      }catch{
        const errText='Error creating CSV file, please contact the administrator of the system.'
        const errTitle='Error downloading raw data'
        const errZone='Report Viewer'
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,errZone)
      }finally{
        this.setMessageVisibleReportViewer(false)
      }
    },
    async downloadRawData(){
      this.setMessageTextReportViewer(downloadRaw_Message)
      this.setMessageVisibleReportViewer(true)
      const reportFilesCount =  await getReportFilesCount(this.getCurrentReportViewer)
      if(reportFilesCount > downloadFilesNumberWarning){
        try{
          await this.$confirm(
            `You are about to download more than ${downloadFilesNumberWarning} files. Are you sure?`,
            'Multiple files',
            'question',
            { confirmButtonText: 'Download' }
          )
        }catch{
          this.setMessageVisibleReportViewer(false)
          return
        }
      }
      const success = await this.downloadRawFilesMiddleware({
        projectId: this.getCurrentReportViewer.projectId,
        reportId: this.getCurrentReportViewer.id,
        clusterId: this.$route.params.clusterId,
      })
      if(!success){
        const errText='Error retrieving raw files from the server, please try in a few minutes.'
        const errTitle='Error downloading Raw Files'
        const errZone='Report Viewer'
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,errZone)
      }
      for(const linkedReport of (this.getCurrentReportViewer.reportLinked || [])){
        const successLinked = await this.downloadRawFilesMiddleware({
          projectId: this.getCurrentReportViewer.projectId,
          reportId: linkedReport,
          clusterId: this.$route.params.clusterId,
        })
        if(!successLinked){
          const errText=`Error retrieving raw files from linked report ${linkedReport}, please try in a few minutes.`
          const errTitle='Error downloading Linked Raw Files'
          const errZone='Report Viewer'
          this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,errZone)
        }
      }
      this.setMessageVisibleReportViewer(false)
    },
    async addReviewers($event) {
      this.$set(this.getCurrentReportViewer, 'reviewers', $event)
      this.userUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
p{
  margin:0
}
.last-modification{
  font-weight:bold;
  font-size: 0.8rem;
}
.p-label-report{
  color: #555;
  font-weight: bold;
}
.p-label-block{
  width: 100%;
}
.p-label-inline{
  min-width: 8rem;
}
.report-date-input{
  border: 0;
}
.text-area-input{
  width: 100%;
  overflow-y: hidden;
  resize: none;
  padding: 0.5rem;
  border: 0;
}
.multiline {
  white-space: pre-wrap;
}
.report-name-input{
  border: 0;
}
.report-name{
  margin:0;
  font-size:1.7rem;
  font-weight: bold;
}
.date-row{
  padding-top: 0.75rem;
}
.more-options{
  position:absolute;
  top:4rem;
  right:2rem;
  font-size: 0.8rem;
}
.logo {
  width: 20px;
  height: 20px;
}
.num-id-edit{
  padding-top: 0.5rem;
  font-size:1.25rem;
}
</style>
